// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__UdcWs","Div":"CustomFadeBox_Div__20Y5A","LargeDiv":"CustomFadeBox_LargeDiv__18yJ3"};